import React from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Title } from "./PagesElements";


const Error = () => {
return (
	<>
	<Navbar />
  <Title/>
	<Footer />
	</>
);
};

export default Error;